import React, { useEffect, useState } from 'react';
import apiClient from '../../../api/apiClient';
import { Row, Col, Form, Badge } from 'react-bootstrap';
import { AlertMassage } from '../../shared';
import { GETEXTERNALUSERSLIST, GETEXTERNALUSER } from '../../../utils/ApiEndPoint';
import { formatDate, maskMobile, downloadFromData } from '../../../utils/utils';
import RemoteTable from '../../shared/RemoteTable';
import { DownLoadExcelReportIcon } from '../../../utils/FontIcon';
// import LiveUserCount from '../../shared/Header/LiveUserCount';

function UserManagement() {
    const [userMaster, setuserMaster] = useState({ items: [] });
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    });
    const defaultPerPageData = 20;
    useEffect(() => {
        fetchUsers(1, defaultPerPageData);
    }, []);
    const fetchUsers = (page = 1, limit) => {
        const alertObj = {
            type: 'danger',
            title: 'Error',
            msg: 'Failed to load Users',
            show: true
        };
        apiClient.get(`${GETEXTERNALUSERSLIST}/?page=${page}&limit=${limit || defaultPerPageData}`)
            .then((response) => {
                if (response.status === 200) {
                    setuserMaster(response.data);
                } else {
                    setShowAlert(alertObj);
                }
            }).catch(() => {
                setShowAlert(alertObj);
            });
    };

    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    const handelUserStatus = (userId, status) => {
        const alertObj = {
            type: 'danger',
            title: 'Error',
            msg: 'Failed to load Roles',
            show: true
        };
        apiClient.patch(`${GETEXTERNALUSERSLIST}/${userId}/status`, {
            "status": status
        }).then((response) => {
            if (response.status === 200) {
                setuserMaster(prevState => {
                    const updatedItems = prevState.items.map(user => {
                        if (user._id === userId) {
                            return { ...user, status: status };
                        }
                        return user;
                    });
                    return { ...prevState, items: updatedItems };
                });
                alertObj.type = 'success';
                alertObj.title = 'Success';
                alertObj.msg = `User has been ${status === 'active' ? 'activated' : 'deactivated'} successfully`;
                setShowAlert(alertObj);
            } else {
                setShowAlert(alertObj);
            }
        }).catch(() => {
            setShowAlert(alertObj);
        });
    }
    const exportUserData = () => {
        apiClient.get(GETEXTERNALUSER)
            .then((response) => {
                if (response.status === 200) {
                    downloadFromData(response.data, `external-users-${new Date().toISOString()}.csv`, 'text/csv');
                } else {
                    setShowAlert({
                        type: 'danger',
                        title: 'Error',
                        msg: 'Failed to export user data',
                        show: true
                    });
                }
            }).catch(() => {
                setShowAlert({
                    type: 'danger',
                    title: 'Error',
                    msg: 'Failed to export user data',
                    show: true
                });
            });
    }
    const headerSortingClasses = { backgroundColor: '#7ae97eff' };

    const columns = [
        {
            dataField: 'id',
            text: 'S.No.',
            formatter: (cell, row, rowIndex) => (
                <span>{rowIndex + 1}</span>
            ),
            headerStyle: { width: '48px' },
        },
        {
            dataField: 'name',
            text: 'User Name',
            sort: true,
            headerSortingClasses
        },
        {
            dataField: 'mobileNumber',
            text: 'Mobile Number',
            formatter: (cell, row) => (
                <span>{maskMobile(row.mobileNumber)}</span>
            ),
        },
        {
            dataField: 'state',
            text: 'State',
        },
        {
            dataField: 'district',
            text: 'District',
        },
        {
            dataField: 'organisation',
            text: 'Organization',
            formatter: (cell, row) => (
                <span>{row.organisation}</span>
            ),
        },
        {
            dataField: 'insuranceCompanyName',
            text: 'Insurance Company',
            formatter: (cell, row) => (
                <span>{row?.insuranceCompanyName || 'N/A'}</span>
            ),
            headerStyle: { width: '200px' },
        },
        
        {
            dataField: 'roles',
            text: 'Designation',
            formatter: (cell, row) => (
                <span>{row.roles && row.roles[0]?.roleName}</span>
            ),
        },
        {
            dataField: 'createdAt',
            text: 'Created on',
            formatter: (cell, row) => (
                <span>{row.createdAt ? formatDate(row.createdAt, false) : ''}</span>
            ),
        },
        {
            dataField: 'status',
            text: 'Status',
            sort: true,
            headerSortingClasses,
            formatter: (cell, row) => (
                <> <Form>
                    <Form.Check
                        type="switch"
                        id={`custom-switch-${row._id}`}
                        label={row.status === 'active' ? <Badge bg="success" style={{ fontSize: '0.45rem', fontWeight: '500', letterSpacing: '0.02rem' }}>Active</Badge> : <Badge bg="light" style={{ fontSize: '0.45rem', fontWeight: '500', color: ' #212529', letterSpacing: '0.02rem' }}>Inactive</Badge>}
                        // label={row.status === 'active' ? <Badge bg="success" style={{ fontSize: '0.5rem' }}>Active</Badge> : <Badge bg="secondary" style={{ fontSize: '0.5rem' }}>Inactive</Badge>}
                        checked={!row.status || row.status === 'active'}
                        onChange={() => handelUserStatus(row._id, row.status === 'active' ? 'inactive' : 'active')}
                        style={{ transform: 'scale(1.5)', transformOrigin: 'left center' }}
                    />
                </Form>

                </>
            ),
        },
    ];
    return (
        <Row>
            <Col md={12} className='mb-4 mt-4 border-bottom'>
                <Row>
                    <Col md={10} xs={12} className='d-flex'>
                        <h2 className='mt-2'>User Management </h2>
                    </Col>
                    <Col md={2} className='d-flex justify-content-end'>
                        <button className="btn btn-sm btn-success" onClick={exportUserData}>
                            <DownLoadExcelReportIcon style={{ width: '16px', height: '16px', marginRight: '5px'}} /> Download
                        </button>
                    </Col>
                </Row>

            </Col>
            
            <Col md={12}>
            
                {userMaster.items?.length && (<RemoteTable data={userMaster.items} totalSize={userMaster.total} page={userMaster.page} columns={columns} updateData={fetchUsers} defaultPerPageData={defaultPerPageData} />)}
            
            </Col>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
        </Row>
    );
}

export default UserManagement;
